import gql from 'graphql-tag';

export const _CREDIT_NOTES = gql`
query getCreditNotes(
	$participant: uuid!
	$recipient: uuid!
	$offset: Int
	$limit: Int
  ) {
	total: risolto_credit_note_aggregate(
	  where: {
		participant: { _eq: $participant }
		recipient: { _eq: $recipient }
	  }
	) {
	  aggregate {
		count
	  }
	}
	risolto_credit_note(
	  where: {
		participant: { _eq: $participant }
		recipient: { _eq: $recipient }
	  }
	  limit: $limit
	  offset: $offset
	  order_by: { is_open: desc, issue_date: desc_nulls_last }
	) {
	  reference
	  created_at
	  interchange_links {
		interchange_by_reference {
		  reference
		  channel
		  direction
		  interchange_events {
			event_type
			last_event_timestamp
		  }
		}
	  }
	  participant
	  amount_currency
	  processing_status
	  status
	  custom_fields
	  origin
	  credit_note_number
	  total_amount
	  open_amount
	  due_date
	  due_amount
	  issue_date
	  file_references
	}
  }  
`;

export const _DEBIT_NOTES = gql`
query getDebitNotes(
	$participant: uuid!
	$recipient: uuid!
	$offset: Int
	$limit: Int
  ) {
	total: risolto_debit_note_aggregate(
	  where: {
		participant: { _eq: $participant }
		recipient: { _eq: $recipient }
	  }
	) {
	  aggregate {
		count
	  }
	}
	risolto_debit_note(
	  where: {
		participant: { _eq: $participant }
		recipient: { _eq: $recipient }
	  }
	  limit: $limit
	  offset: $offset
	  order_by: { is_open: desc, issue_date: desc_nulls_last }
	) {
	  reference
	  created_at
	  participant
	  amount_currency
	  processing_status
	  custom_fields
	  origin
	  debit_note_number
	  total_amount
	  open_amount
	  due_date
	  issue_date
	}
  }  
`;
